export const SET_APP_SCHEMAS = 'SET_APP_SCHEMAS';
export const setAppSchemasAction = (appSchemas) => ({
  type: SET_APP_SCHEMAS,
  payload: appSchemas,
});
